var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkspace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ide_icon",
    "data-name": "ide icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2381",
    "data-name": "Path 2381",
    d: "M4,4H28V28H4Z",
    transform: "translate(-4 -4)",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "view_in_ar_FILL0_wght400_GRAD0_opsz48",
    "data-name": "view in ar FILL0 wght400 GRAD0 opsz48",
    d: "M14.67,25.06l-6.79-4a1.84,1.84,0,0,1-.53-.58,1.36,1.36,0,0,1-.21-.76V11.78A1.47,1.47,0,0,1,7.32,11a1.42,1.42,0,0,1,.56-.58l6.91-4.1a1.29,1.29,0,0,1,1.5,0l6.91,4.1a1.7,1.7,0,0,1,.55.58,1.46,1.46,0,0,1,.19.76v7.93a1.36,1.36,0,0,1-.21.76,1.84,1.84,0,0,1-.53.58l-6.91,4a1.49,1.49,0,0,1-1.62,0Zm0-2.12v-6.7L9,13v6.55Zm1.8,0,5.71-3.41V13l-5.71,3.26Zm-.9-8.32,5.68-3.29L15.54,8.07,9.86,11.33Z",
    transform: "translate(-4 -4)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspace);
export default __webpack_public_path__ + "static/media/workspace.ccb2be64ddad315faafb1950dfd24aee.svg";
export { ForwardRef as ReactComponent };